import http from '../interceptors/Intercepter';

export const createToolTip = async (username, tooltipVOToCreate) => {
  try {
    const { data } = await http.post('/api/tooltip/create', { username, tooltipVOToCreate });
    return [data, null];
  } catch (error) {
    return [null, error];
  }
};

export const updateToolTip = async (username, tooltipVOToUpdate) => {
  try {
    const { data } = await http.put('/api/tooltip/update', { username, tooltipVOToUpdate });
    return [data, null];
  } catch (error) {
    return [null, error];
  }
};

export const retrieveToolTip = async (username, tooltipExternalReference) => {
  try {
    const { data } = await http.post('/api/tooltip/view', { username, tooltipExternalReference });
    return [data, null];
  } catch (error) {
    return [null, error];
  }
};

export const retrieveAllToolTips = async (username) => {
  try {
    const { data } = await http.get('/api/tooltip/viewAll?username=' + username);
    return [data, null];
  } catch (error) {
    return [null, error];
  }
};
